import React from "react";
import { Container, Card } from "./styles";

const AbsoluteDataOperationArea = ({ data, npsGeral }) => {
  return (
    <Container>
      <Card>
        <span>SLA</span>
        <p>
          <strong>{data?.sla?.includes("NaN") ? "---" : data?.sla}</strong>/12h
        </p>
      </Card>
      {/* <Card>
        <span>Certificados Emitidos</span>
        <p><strong>{data?.certificados_gerados}</strong></p>
      </Card> */}
      <Card>
        <span>
          Dúvidas Pendentes
          <br />
        </span>
        {/* <p><strong>{data?.total.totalGeral}</strong>/{data?.total.somaRespondida}</p> */}
        <p>
          <strong>{data?.total?.somaPendente || 0}</strong>
        </p>
      </Card>
      <Card>
        <span>
          Envios Pendentes
          <br />
        </span>
        <p>
          <strong>{data?.count_envios_pendentes || 0}</strong>
        </p>
      </Card>
      <Card>
        <span>Aplicações Pendentes</span>
        {/* <p><strong>{data?.total.somaPendente}</strong>/{data?.total.totalGeral}</p> */}
        <p>
          <strong>{data?.projetos_pendentes || 0}</strong>
        </p>
      </Card>
      <Card>
        <span>NPS Geral</span>
        <p>
          <strong>{npsGeral || 0}%</strong>
        </p>
      </Card>
      <Card>
        <span>Primeiro Contato</span>
        <p>
          <strong>{data?.primeiro_contato || 0}</strong>/24h
        </p>
      </Card>
    </Container>
  );
};

export default AbsoluteDataOperationArea;
